export default function getQueryParamValue(
  queryVal: string[] | string | null | undefined,
  defaultValue = '',
): string {
  if (Array.isArray(queryVal)) {
    return queryVal[0];
  }
  return queryVal || defaultValue;
}
